// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'normalize.css'
import '@/platform/hmap/env'
// import i18n from './i18n/vue-i18n'
import './assets/css/main'
import './utils/autoAdapt'
import loading from '@/plugins/loading'
import gallery from 'img-vuer'
import FastClick from 'fastclick'
// import 'lib-flexible'
// import {setRemInit} from '@/utils/rem' // 进行初始化立即运行
// 公共组件
import './utils/common'
import './utils/filters'
// import wx from 'weixin-js-sdk'
import wx from 'weixin-jsapi'
// 登陆
// import {
//   getCurrentUser,
//   wxAuthConfig,
//   getCurrentUserRoles,
// } from './service/auth/loginService'

// 全局引入插件
import VyInputText from '&/basic/VyInputText.vue'
import VyInputSelect from '&/basic/VyInputSelect.vue'
import VyInputLookup from '&/basic/VyInputLookup.vue'
import VyInputLookupPlus from '&/basic/VyInputLookupPlus.vue'
import VyInputTextarea from '&/basic/VyInputTextarea.vue'
import VyInputInteger from '&/basic/VyInputInteger.vue'
import VyInputDecimal from '&/basic/VyInputDecimal.vue'
import VyInputDate from '&/basic/VyInputDate.vue'
import VyInputDateTime from '&/basic/VyInputDateTime.vue'
import VyInputTime from '&/basic/VyInputTime.vue'
import VyInputRadio from '&/basic/VyInputRadio.vue'
import VySection from '&/basic/VySection'
import VyCheckListPage from '&/basic/VyCheckListPage'
import vueSignature from 'vue-signature'
import VyDetail from '&/crm-ui/VyDetail'
import VyEditBtn from '&/crm-ui/VyEditBtn'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// setRemInit()
// import {getCurrentUser} from '@/service/auth/loginService'
Vue.prototype.wx = wx
Vue.use(loading)
Vue.config.devtools = true
Vue.component('vy-input-text', VyInputText)
Vue.component('vy-input-select', VyInputSelect)
Vue.component('vy-input-lookup', VyInputLookup)
Vue.component('vy-input-lookupplus', VyInputLookupPlus)
Vue.component('vy-input-textarea', VyInputTextarea)
Vue.component('vy-input-integer', VyInputInteger)
Vue.component('vy-input-decimal', VyInputDecimal)
Vue.component('vy-input-date', VyInputDate)
Vue.component('vy-input-datetime', VyInputDateTime)
Vue.component('vy-input-time', VyInputTime)
Vue.component('vy-input-radio', VyInputRadio)
Vue.component('vy-section', VySection)
Vue.component('vy-check-list-page', VyCheckListPage)
Vue.component('vy-detail', VyDetail)
Vue.component('vy-edit-btn', VyEditBtn)
Vue.use(gallery)
Vue.use(vueSignature)

// 如果是 alpha:上线前测试，引入 vconsole 调试工具 process.env.BASE_URL
if(process.env.NODE_ENV === 'uat' || process.env.NODE_ENV === 'development') {
  const VConsole = require('vconsole')
  // eslint-disable-next-line no-new
  new VConsole()
}

// FastClick.attach(document.body)

const CONST_STRING = require('../config/CONST')
Vue.config.productionTip = false
Vue.prototype.$CONST_STRING = CONST_STRING
FastClick.prototype.focus = function (targetElement) {
  let length
  if(targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'number') {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}
// eslint-disable-next-line no-new
// new Vue({
//   el: '#app',
//   i18n,
//   router,
//   store,
//   components: {App},
//   template: '<App/>',
// })
window.onload = function () {
  FastClick.attach(document.body)
  // localStorage.clear()
  // authLogin()
  init()
}
// async function setApp () {
//   // await authLogin()
//   init()
//   // getCurrentUser()
//   // wxAuthConfig(false, 0)
//   // getCurrentUserRoles()
// }
function init () {
  window.vm = new Vue({
    store,
    router,
    async created () {
      // await getCurrentUser()
      // await getCurrentUser()
      // await authLogin()
      // getCurrentUser()
      // wxAuthConfig(false, 0)
      // getCurrentUserRoles()
    },
    destroyed () {
      // localStorage.clear()
    },
    render: h => h(App),
  }).$mount('#app')
}



// WEBPACK FOOTER //
// ./src/main.js